import { Component, Input } from '@angular/core';
import { FormViewState } from 'src/app/common/models/form-view-state';

@Component({
  selector: 'form-history-rsswa',
  templateUrl: './form-history-rsswa.component.html',
  styleUrls: ['./form-history-rsswa.component.scss']
})
export class FormHistoryRsswaComponent {

  @Input() originalBody: any;
  @Input() update: any;
  @Input() status?: FormViewState;

}
